import {
  __experimentalInputControl as InputControl,
  PanelBody,
  ToggleControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";

import { InspectorControls, PanelColorSettings } from "@wordpress/block-editor";

import { __ } from "@wordpress/i18n";

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const {
    name,
    isRequired,
    label,
    id,
    labelPosition,
    size,
    enabledColor,
    disabledColor,
    defaultChecked,
  } = attributes;

  return (
    <>
      <InspectorControls>
        <PanelBody title={__("Settings")}>
          <InputControl
            label={__("Label")}
            value={label}
            onChange={(v) => setAttributes({ label: v })}
          />
          <InputControl
            label={__("Name")}
            value={name}
            onChange={(v) => setAttributes({ name: v })}
          />
          <InputControl
            label={__("Id")}
            value={id}
            onChange={(v) => setAttributes({ id: v })}
          />
          <ToggleControl
            __nextHasNoMarginBottom
            label={__("Is required")}
            checked={isRequired}
            onChange={(v) => {
              setAttributes({ isRequired: v });
            }}
          />
          <ToggleControl
            __nextHasNoMarginBottom
            label={__("Default checked")}
            checked={defaultChecked}
            onChange={(v) => {
              setAttributes({ defaultChecked: v });
            }}
          />
        </PanelBody>
        <PanelBody title={__("Switcher Settings", "brandy-blocks")}>
          <div className="components-base-control">
            <label className="components-base-control__label">
              {__("Label Position", "brandy")}
            </label>
            <ToggleGroupControl
              value={labelPosition || "left"}
              onChange={(value) => setAttributes({ labelPosition: value })}
              isBlock
            >
              <ToggleGroupControlOption
                value="left"
                label={__("Left", "brandy-blocks")}
              />
              <ToggleGroupControlOption
                value="right"
                label={__("Right", "brandy-blocks")}
              />
            </ToggleGroupControl>
          </div>
          <div className="components-base-control">
            <label className="components-base-control__label">
              {__("Size", "brandy")}
            </label>
            <ToggleGroupControl
              value={size || "medium"}
              onChange={(value) => setAttributes({ size: value })}
              isBlock
            >
              <ToggleGroupControlOption
                value="small"
                label={__("Small", "brandy-blocks")}
              />
              <ToggleGroupControlOption
                value="medium"
                label={__("Medium", "brandy-blocks")}
              />
              <ToggleGroupControlOption
                value="large"
                label={__("Large", "brandy-blocks")}
              />
            </ToggleGroupControl>
          </div>
        </PanelBody>
      </InspectorControls>
      <InspectorControls group="styles">
        <PanelColorSettings
          title={__("Switcher Colors", "brandy-blocks")}
          initialOpen={true}
          enableAlpha={true}
          colorSettings={[
            {
              label: __("Enabled", "brandy-blocks"),
              value: enabledColor,
              onChange: (newColor) =>
                setAttributes({
                  enabledColor: newColor,
                }),
              clearable: true,
            },
            {
              value: disabledColor,
              onChange: (newColor) =>
                setAttributes({
                  disabledColor: newColor,
                }),
              clearable: true,
              label: __("Disabled", "brandy-blocks"),
            },
          ]}
        />
      </InspectorControls>
    </>
  );
}
